exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter .aside-panel {\n  height: calc(100% - 1px);\n  top: unset;\n  bottom: 1px;\n  border-radius: 0;\n  transform: translateX(-100%);\n  transition: all 150ms;\n  box-shadow: none;\n}\n.filter.opened .aside-panel {\n  box-shadow: 10px 0px 30px rgba(0, 0, 0, 0.2);\n  transform: translateX(0);\n}\n", ""]);

// exports
